import { useNavigate } from "react-router-dom";
import {
  formatAmount,
  formatTime,
  getDayFromDate,
  getStatusBadge,
} from "../../utility/Common";
import { TimeIcon } from "../../icons/TimeIcon";
import { RoutePaths } from "../../utility/RoutePaths";

const ClassDetailsBox = ({ classDetails, additionalTitle = "" }) => {
  const navigate = useNavigate();

  const openClassDetailsPage = () => {
    navigate(
      `${RoutePaths.STUDENT_CLASS_DETAILS_PAGE}?classId=${classDetails.ClassId}`,
    );
  };

  if (classDetails === null) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-primary-600"></div>
    );
  }
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-l-4 border-primary-600">
      <div className="flex items-center justify-between mb-4">
        <h2
          className="text-2xl font-bold text-gray-900 cursor-pointer"
          onClick={() => openClassDetailsPage()}
        >
          {classDetails.Name}{" "}
          {additionalTitle.length > 0 && " - " + additionalTitle}
        </h2>
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <span className="text-sm font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full">
              {classDetails.ClassType?.Name}
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500">Status:</span>
          {getStatusBadge(classDetails.Status)}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">
            Monthly Fee | මාසික ගාස්තුව:{" "}
          </span>
          <p className="font-semibold text-sm text-gray-900">
            {formatAmount(classDetails.ClassFee, true)}
          </p>
        </div>
        {/* <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500">Group link: </span>
          <p className="font-semibold text-sm text-primary-600 cursor-pointer">
            <a
              href={classDetails.WhatsAppLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>
          </p>
        </div> */}
      </div>

      {(classDetails.StartTime || classDetails.EndTime) && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-2">
            <TimeIcon />
            <span className="text-sm text-gray-500">
              Class Time | පන්ති වේලාව:
            </span>
            <span className="font-semibold text-sm text-gray-900">
              {getDayFromDate(classDetails.StartDate) +
                " (" +
                formatTime(classDetails.StartTime) +
                " - " +
                formatTime(classDetails.EndTime) +
                ")"}
            </span>
          </div>
        </div>
      )}

      {classDetails.WhatsAppLink && classDetails.WhatsAppLink.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center">
          <span className="text-md text-gray-500">
            පන්තියට අදාල දැනුවත්වීම් සඳහා WhatsApp සමූහයට සම්බන්ධ වීම අනිවාර්ය
            වේ.
          </span>

          <a
            href={classDetails.WhatsAppLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              type="button"
              className={`text-sm font-medium ml-4 px-4 py-2 rounded-md transition-colors bg-green-600 text-white hover:bg-green-700`}
            >
              Join WhatsApp Group
            </button>
          </a>
        </div>
      )}
    </div>
  );
};

export default ClassDetailsBox;
